"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var classnames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var date_utils_1 = require("./date_utils");
var isSameDay = require("date-fns/is_same_day");
var isBefore = require("date-fns/is_before");
var isAfter = require("date-fns/is_after");
var getDay = require("date-fns/get_day");
var getDate = require("date-fns/get_date");
var getMonth = require("date-fns/get_month");
var dateFormat_1 = require("../../../utils/dateFormat");
var Day = /** @class */ (function (_super) {
    __extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (event) {
            if (!_this.isDisabled() && _this.props.onClick) {
                _this.props.onClick(event);
            }
        };
        _this.handleMouseEnter = function (event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) {
                _this.props.onMouseEnter(event);
            }
        };
        _this.isSameDay = function (other) {
            return isSameDay(_this.props.day, other);
        };
        _this.isKeyboardSelected = function () {
            return (!_this.props.inline &&
                !_this.isSameDay(_this.props.selected) &&
                _this.isSameDay(_this.props.preSelection));
        };
        _this.isDisabled = function () {
            return date_utils_1.isDayDisabled(_this.props.day, _this.props);
        };
        _this.isHighlighted = function () {
            var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
            if (!highlightDates) {
                return false;
            }
            return highlightDates.some(function (testDay) { return isSameDay(day, testDay); });
        };
        _this.isInRange = function () {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) {
                return false;
            }
            return date_utils_1.isDayInRange(day, startDate, endDate);
        };
        _this.isInSelectingRange = function () {
            var _a = _this.props, day = _a.day, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectingDate = _a.selectingDate, startDate = _a.startDate, endDate = _a.endDate;
            if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
                return false;
            }
            if (selectsStart &&
                endDate &&
                (isSameDay(selectingDate, endDate) || isBefore(selectingDate, endDate))) {
                return date_utils_1.isDayInRange(day, selectingDate, endDate);
            }
            if (selectsEnd &&
                startDate &&
                (isSameDay(selectingDate, startDate) || isAfter(selectingDate, startDate))) {
                return date_utils_1.isDayInRange(day, startDate, selectingDate);
            }
            return false;
        };
        _this.isSelectingRangeStart = function () {
            if (!_this.isInSelectingRange()) {
                return false;
            }
            var _a = _this.props, day = _a.day, selectingDate = _a.selectingDate, startDate = _a.startDate, selectsStart = _a.selectsStart;
            if (selectsStart) {
                return isSameDay(day, selectingDate);
            }
            else {
                return isSameDay(day, startDate);
            }
        };
        _this.isSelectingRangeEnd = function () {
            if (!_this.isInSelectingRange()) {
                return false;
            }
            var _a = _this.props, day = _a.day, selectingDate = _a.selectingDate, endDate = _a.endDate, selectsEnd = _a.selectsEnd;
            if (selectsEnd) {
                return isSameDay(day, selectingDate);
            }
            else {
                return isSameDay(day, endDate);
            }
        };
        _this.isRangeStart = function () {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) {
                return false;
            }
            return isSameDay(startDate, day);
        };
        _this.isRangeEnd = function () {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) {
                return false;
            }
            return isSameDay(endDate, day);
        };
        _this.isWeekend = function () {
            var weekday = getDay(_this.props.day);
            return weekday === 0 || weekday === 6;
        };
        _this.isOutsideMonth = function () {
            return (_this.props.month !== undefined &&
                _this.props.month !== getMonth(_this.props.day));
        };
        _this.getClassNames = function () {
            return classnames('ee_react-datepicker__day', {
                'ee_react-datepicker__day--disabled': _this.isDisabled(),
                'ee_react-datepicker__day--selected': _this.isSameDay(_this.props.selected),
                'ee_react-datepicker__day--keyboard-selected': _this.isKeyboardSelected(),
                'ee_react-datepicker__day--highlighted': _this.isHighlighted(),
                'ee_react-datepicker__day--range-start': _this.isRangeStart(),
                'ee_react-datepicker__day--range-end': _this.isRangeEnd(),
                'ee_react-datepicker__day--in-range': _this.isInRange(),
                'ee_react-datepicker__day--in-selecting-range': _this.isInSelectingRange(),
                'ee_react-datepicker__day--selecting-range-start': _this.isSelectingRangeStart(),
                'ee_react-datepicker__day--selecting-range-end': _this.isSelectingRangeEnd(),
                'ee_react-datepicker__day--today': _this.isSameDay(new Date()),
                'ee_react-datepicker__day--weekend': _this.isWeekend(),
                'ee_react-datepicker__day--outside-month': _this.isOutsideMonth()
            });
        };
        return _this;
    }
    Day.prototype.render = function () {
        return (React.createElement("div", { className: this.getClassNames(), onClick: this.handleClick, onMouseEnter: this.handleMouseEnter, "aria-label": "" + dateFormat_1.format(this.props.day, 'DD. MMMM YYYY'), "aria-disabled": this.isDisabled(), role: "option" },
            React.createElement("div", { className: "ee_react-datepicker__day-wrapper" }, getDate(this.props.day))));
    };
    Day.displayName = 'Day';
    Day.propTypes = {
        day: PropTypes.object.isRequired,
        endDate: PropTypes.object,
        minDate: PropTypes.object,
        maxDate: PropTypes.object,
        highlightDates: PropTypes.array,
        filterDate: PropTypes.func,
        excludeDates: PropTypes.array,
        includeDates: PropTypes.array,
        inline: PropTypes.bool,
        month: PropTypes.number,
        onClick: PropTypes.func,
        onMouseEnter: PropTypes.func,
        preSelection: PropTypes.object,
        selected: PropTypes.object,
        selectingDate: PropTypes.object,
        selectsEnd: PropTypes.bool,
        selectsStart: PropTypes.bool,
        startDate: PropTypes.object
    };
    Day.defaultProps = {};
    return Day;
}(React.Component));
exports.Day = Day;
exports.default = Day;
//# sourceMappingURL=day.js.map
